export default {
  back: 'Back ',
}
